<div class="tw-flex tw-flex-col tw-gap-6 tw-rounded-lg md:tw-h-full md:tw-w-full">
  <!-- Local Notifications Permission -->
  <app-widget [title]="'localNotifications' | i18n" [iconName]="'notifications'">
    @if (pushNotificationService.isMobile) {
      @if (pushNotificationService.permissionState() === "granted") {
        <div class="tw-flex tw-items-center tw-gap-2 tw-text-dt-text-success">
          <icon [name]="'calendar'" [size]="4"></icon>
          <span>{{ "pushNotificationsPermissionGranted" | i18n }}</span>
        </div>
      } @else if (pushNotificationService.permissionState() === "denied") {
        <p class="tw-text-dt-text-error tw-mb-0">
          {{ "pushNotificationsPermissionDenied" | i18n }}
        </p>
      } @else {
        <p class="tw-mb-3 tw-text-dt-text-secondary">{{ "notificationsDesc" | i18n }}</p>
        <app-gloss-button [options]="enableNotificationsButton"></app-gloss-button>
      }
    } @else {
      <p class="tw-text-dt-text-tertiary tw-text-sm">{{ "pushNotificationsMobileOnly" | i18n }}</p>
    }
  </app-widget>

  <!-- Bill Due Alerts -->
  <app-widget [title]="'billDueAlerts' | i18n" [iconName]="'calendar'">
    <p class="tw-text-dt-text-secondary tw-mb-4">{{ "billDueAlertsDesc" | i18n }}</p>

    <!-- Existing Alerts List -->
    @if (!pushNotificationService.isLoading() && pushNotificationService.billAlerts().length > 0) {
      <div class="tw-flex tw-flex-col tw-gap-3 tw-mb-4">
        @for (alert of pushNotificationService.billAlerts(); track alert.id) {
          <div
            class="tw-flex tw-flex-col tw-rounded-2xl tw-bg-dt-surface-elevated tw-shadow-card-elevated tw-p-4 tw-gap-3"
          >
            <!-- Top row: payee + delete -->
            <div class="tw-flex tw-items-start tw-justify-between tw-gap-2">
              <div class="tw-flex tw-flex-col tw-gap-2">
                <span class="tw-font-semibold tw-text-dt-text-headings tw-text-base">{{
                  alert.payee
                }}</span>
                <span
                  class="tw-self-start tw-text-xs tw-font-medium tw-px-2.5 tw-py-1.5 tw-rounded-full tw-bg-dt-surface-elevated tw-shadow-card-elevated tw-text-dt-text-secondary"
                >
                  {{ getPaymentTypeLabel(alert.paymentType) }}
                </span>
              </div>
              <button
                type="button"
                class="tw-shrink-0 tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-full tw-bg-dt-surface-elevated tw-shadow-card-elevated"
                (click)="deleteAlert(alert)"
              >
                <icon [name]="'close'" [size]="3" [currentColor]="'danger'"></icon>
              </button>
            </div>

            <!-- Divider -->
            <div class="tw-border-0 tw-border-t tw-border-neutral-100"></div>

            <!-- Info row: due date + amount -->
            <div class="tw-flex tw-justify-between tw-gap-4">
              <div class="tw-flex tw-flex-col tw-gap-0.5">
                <span
                  class="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-dt-text-disabled"
                >
                  {{ "billDueDate" | i18n }}
                </span>
                <span class="tw-text-sm tw-font-medium tw-text-dt-text-secondary">
                  {{ formatDueDate(alert.dueDate) }}
                </span>
              </div>
              <div class="tw-flex tw-flex-col tw-gap-0.5 tw-text-right">
                <span
                  class="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-dt-text-disabled"
                >
                  {{ "billAmount" | i18n }}
                </span>
                <span class="tw-text-sm tw-font-medium tw-text-dt-text-secondary">
                  {{ alert.amount != null ? (alert.amount | number: "1.2-2") : ("unknown" | i18n) }}
                </span>
              </div>
            </div>

            <!-- Notify chips -->
            <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
              <span
                class="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-dt-text-disabled"
              >
                {{ "notificationDate" | i18n }}
              </span>
              @for (days of alert.notifyDaysBefore; track days) {
                <span
                  class="tw-text-xs tw-font-medium tw-px-2.5 tw-py-1 tw-rounded-full tw-bg-dt-custom-teal-9 tw-text-dt-text-contrast"
                >
                  {{ pushNotificationService.getNotifyDaysLabel(days) }}
                </span>
              }
            </div>
          </div>
        }
      </div>
    } @else if (!pushNotificationService.isLoading()) {
      <p class="tw-text-dt-text-disabled tw-text-sm tw-mb-4">{{ "noBillAlerts" | i18n }}</p>
    }

    <!-- Add Button -->
    <app-gloss-button [options]="addAlertButton"></app-gloss-button>
  </app-widget>
</div>
